import { Link, useLocation } from 'react-router-dom';
import {
    FaHome,
    FaCalendar,
    FaMap,
    FaPaw,
    FaFilter,
    FaFile,
    FaUsers,
    FaChevronDown,
    FaChevronUp,
    FaVectorSquare,
    FaLocationArrow,
    FaUser,
    FaComment,
} from 'react-icons/fa';
import { TbFence } from 'react-icons/tb';
import classNames from 'classnames';
import { IconType } from 'react-icons/lib';
import { useCallback } from 'react';
import { APP_ROUTES } from '../../routes';
import { useAppDispatch } from '../../types/hooks';
import { logAction } from '../../store/actions/logActions';

interface IconDictionary {
    [key: string]: IconType;
}

export const ICONS: IconDictionary = {
    home: FaHome,
    calendar: FaCalendar,
    huntingGround: TbFence,
    geofence: FaVectorSquare,
    map: FaMap,
    filter: FaFilter,
    document: FaFile,
    teams: FaUsers,
    up: FaChevronUp,
    down: FaChevronDown,
    paw: FaPaw,
    device: FaLocationArrow,
    contacts: FaUser,
    chat: FaComment,
};

type SidebarkLinkProps = {
    path: string;
    title: string;
    icon: string;
};
const SidebarLink = (props: SidebarkLinkProps) => {
    const { path, title, icon } = props;
    const r = useLocation();
    const d = useAppDispatch();

    const linkClass = classNames({
        link: true,
        active: r.pathname == path || (path === APP_ROUTES.map && r.pathname === APP_ROUTES.home),
    });

    const iconStyles = classNames({
        icon: true,
        active: r.pathname == path || (path === APP_ROUTES.map && r.pathname === APP_ROUTES.home),
    });

    const Icon = ICONS[icon];

    const onLinkClick = useCallback(async () => {
        let activityId = -1;
        switch (path) {
            case APP_ROUTES.devices:
                activityId = 23;
                break;
            default:
                activityId = -1;
        }

        if (activityId !== -1) {
            d(logAction({ activityId }));
        }
    }, [r.pathname, path]);

    return (
        <div className="d-flex flex-row justify-content-start align-items-center">
            <Icon className={iconStyles} />
            <Link className={linkClass} to={path} onClick={onLinkClick}>
                {title}
            </Link>
        </div>
    );
};

export default SidebarLink;
